import React, { useEffect } from 'react';
import lottie from 'lottie-web';
import lottieJson from './mappers';

const Lottie = (props) => {
  const {
    animationName,
  } = props;

  const loadAnimation = () => {
    lottie.loadAnimation({
      container: document.getElementById(`lottie--${animationName}`),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: lottieJson[animationName],
    });
  };

  useEffect(() => {
    loadAnimation();
  }, []);

  return (
    <div className="measurement--lottie" id={`lottie--${animationName}`} />
  );
};

export default Lottie;
